import { useLazyQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";
import { AI_AGENT_QUERY_PARAMS } from "Pages/agentBuilder/Pages/constants";
import { AIAgentPaths } from "Pages/agentBuilder/Pages/paths";

import { fetchAiAgents, GetAiAgentsResponse } from "./queries";
import { SpotlightAiAgentsItem } from "./SpotlightAiAgentsItem";

export const useGetSearchAiAgents = (onCallback: () => void) => {
    const navigate = useNavigate();
    const [getAiAgents, { loading }] = useLazyQuery<GetAiAgentsResponse>(fetchAiAgents);

    const handleGetAiAgents = async (searchValue: string) => {
        const aiAgents = await getAiAgents({
            variables: {
                queryParams: { filterBy: [{ key: "internalName", value: searchValue, operator: "contains" }] },
            },
        });
        const aiAgentsData = aiAgents.data?.getAiAgents.items.map((item) => {
            const basePath = `${AppPagePaths.aiAgents}/${AIAgentPaths.customEdit}/${item.id}/${item.version}`;
            const variantId = item.variant?.id;
            const route = variantId
                ? `${basePath}?${AI_AGENT_QUERY_PARAMS.VARIANT_ID}=${encodeURIComponent(variantId)}`
                : basePath;

            return {
                label: (
                    <SpotlightAiAgentsItem
                        name={item.internalName}
                        description={`${item.name} (${item.agentEmail})`}
                        searchValue={searchValue}
                        route={route}
                        onCallback={() => {
                            onCallback();
                            navigate(route);
                        }}
                    />
                ),
                value: item.id,
            };
        });

        if (!aiAgentsData?.length || !searchValue) {
            return [];
        }

        return [
            {
                label: "AI Agents",
                options: aiAgentsData,
            },
        ];
    };

    return {
        getAiAgents: handleGetAiAgents,
        loading,
    };
};
